export const searchSymbolMapper = (data) => {
    var _a, _b;
    let result = { data: { symbolList: [] } };
    if (data && (data === null || data === void 0 ? void 0 : data.resLst) && ((_a = data === null || data === void 0 ? void 0 : data.resLst) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        (_b = data === null || data === void 0 ? void 0 : data.resLst) === null || _b === void 0 ? void 0 : _b.map((symbol) => {
            let symbolData = {};
            symbolData.displayName = symbol.dpNm;
            symbolData.displayValue = symbol.dpVal;
            symbolData.index = symbol.idx;
            symbolData.instrument = symbol.inst;
            result.data.symbolList.push(symbolData);
        });
    }
    return result;
};
